import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { BUTTON_ACCENT_COLORS } from '../styles/buttonStyles';
const ACCENT_COLOR_SIZE_PX = 5;
export const HEIGHT_RESERVED_FOR_ACCENT_COLOR = 2.5 * ACCENT_COLOR_SIZE_PX;
export const ButtonAccentColorDisplay = ({ accentColor, buttonWidth, buttonHeight }) => {
    const width = buttonWidth * 0.8;
    const containerCss = useMemo(() => css `
      position: absolute;
      left: ${(buttonWidth - width) / 2}px;
      top: ${buttonHeight - HEIGHT_RESERVED_FOR_ACCENT_COLOR}px;
      width: ${width}px;
      height: ${ACCENT_COLOR_SIZE_PX}px;
      background-color: ${BUTTON_ACCENT_COLORS[accentColor]};
      border-radius: ${ACCENT_COLOR_SIZE_PX / 2}px;
      pointer-events: none;
    `, [accentColor, buttonHeight, buttonWidth, width]);
    return _jsx("div", { css: containerCss });
};
